import { render, staticRenderFns } from "./TabStyle.vue?vue&type=template&id=00e17bd1&"
import script from "./TabStyle.vue?vue&type=script&lang=js&"
export * from "./TabStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports